import { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useCategories = () => {
  const [category, setCategory] = useState("");
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState([]);

  // fetchCategories defined outside useEffect
  const fetchCategories = async () => {
    try {
      const res = await fetch(`${BASE_URL}/categories/list/`,{
          headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        }
      });
      const data = await res.json();
      setCategories(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCategories(); // call inside useEffect
  }, []);

  return {
    category,
    setCategory,
    search,
    setSearch,
    categories,
    fetchCategories, // optional: expose if you want to manually refresh
  };
};

export default useCategories